import { Card, Table } from "antd";
import { OriginPill, StatusPill } from "./StatusBadges";
import { formatCurrency, formatDateTime } from "../utils/format";
import { FLOW_TYPE_LABELS, formatCarrier } from "../constants";

const columns = [
  {
    title: "Pedido",
    key: "orderNumber",
    render: (_, pedido) => `#${pedido.orderNumber || "-"}`,
  },
  { title: "Cliente", key: "user", render: (_, pedido) => pedido.user?.fullName || "-" },
  {
    title: "Origem",
    key: "origin",
    render: (_, pedido) => <OriginPill origin={pedido.origin} />,
  },
  {
    title: "Status",
    key: "status",
    render: (_, pedido) => <StatusPill status={pedido.status} />,
  },
  { title: "Locker", key: "colleto", render: (_, pedido) => pedido.colleto?.name || "-" },
  {
    title: "Tipo",
    key: "flowType",
    render: (_, pedido) => {
      const flowType = pedido.reserva?.flowType;
      const carrier = pedido.reserva ? formatCarrier(pedido.reserva) : "";
      return (
        <div>
          <div style={{ color: "var(--te-primary)", fontWeight: 600 }}>
            {FLOW_TYPE_LABELS[flowType] || flowType || "-"}
          </div>
          {carrier ? <div className="te-muted">{carrier}</div> : null}
        </div>
      );
    },
  },
  { title: "Valor", key: "valor", render: (_, pedido) => formatCurrency(pedido.valor) },
  {
    title: "Criado em",
    key: "createdAt",
    render: (_, pedido) => formatDateTime(pedido.createdAt),
  },
];

export function PedidoTable({ pedidos, loading, onSelect }) {
  return (
    <Card className="te-card">
      <div style={{ marginBottom: 16 }}>
        <h3 style={{ margin: 0, color: "var(--te-primary)" }}>Lista de pedidos</h3>
        <p className="te-kicker">Visualização simplificada dos pedidos do sistema.</p>
      </div>
      <Table
        dataSource={pedidos}
        columns={columns}
        rowKey={(pedido) => pedido.id}
        loading={loading}
        pagination={{ pageSize: 10, showSizeChanger: false }}
        onRow={(pedido) => ({
          onClick: () => onSelect(pedido.id),
          style: { cursor: "pointer" },
        })}
      />
    </Card>
  );
}
